


























import { Component, Vue, Prop } from "vue-property-decorator";
import { MetadataConfiguration } from "@/server/app.dtos";
import { GenerateMetadataComposer } from "@/utilities/helpers";

@Component
export default class MetadataFormComponent extends Vue {
  @Prop() metadata!: MetadataConfiguration;
  @Prop() folder!: string;
  current!: MetadataConfiguration;
  isValid: boolean = false;

  get hasfields(): boolean {
    return this.current?.groups ? this.current.groups.length > 0 : false;
  }

  created() {
    this.current = new MetadataConfiguration();
    this.current.init(this.metadata);
  }

  onConfirm() {
    if (!this.isValid) return;
    this.$emit("onSave", GenerateMetadataComposer(this.current));
  }
}
